"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAlert = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const components_1 = require("../components");
function useAlert() {
    const [content, setContent] = react_1.useState(null);
    const dismiss = react_1.useCallback(() => {
        var _a;
        setContent(null);
        (_a = content === null || content === void 0 ? void 0 : content.onDismiss) === null || _a === void 0 ? void 0 : _a.call(content);
    }, [content]);
    return react_1.useMemo(() => {
        const alert = (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: content ? (jsx_runtime_1.jsx(components_1.Alert, Object.assign({ onDismiss: dismiss, title: content.title }, { children: typeof content.content === 'function' ? content.content({ dismiss }) : content.content }), void 0)) : null }, void 0));
        return [alert, setContent];
    }, [content, dismiss]);
}
exports.useAlert = useAlert;
//# sourceMappingURL=useAlert.js.map